import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import StoreService from "../../../services/StoreService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListStore from "../Components/ListStore";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewStore() {
  const [stores, setStores] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO SINGLE SELECT
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // const messageTimer = useRef(null);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await StoreService.getAll(currentPage, itemsPerPage);

      const data = res?.data || [];
      const total = res?.total || 0;

      setStores(data);
      setPageCount(Math.ceil(total / itemsPerPage));
    } catch (err) {
      console.error(err);
      showMessage("Error fetching data", "error");
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    fetchData();
  }, [currentPage]);


  useEffect(() => {
    if (location.state?.refresh) {
      fetchData();
      navigate(location.pathname, { replace: true });
    }
  }, [location]);

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const handleAdd = () => {
    navigate("/cpnl/store/add");
  };

  const handleModify = () => {
    if (!selected) {
      showMessage("Please select one store to modify.");
      return;
    }
    navigate(`/cpnl/store/add/${selected}`);
  };

  const handleToggleStatus = async (store) => {
    const newStatus = store.status === "Active" ? "Inactive" : "Active";
    if (!window.confirm(`Are you sure do you want to change Store as ${newStatus}?`))
      return;

    setLoading(true);
    try {
      await StoreService.updateStatus(store.id, newStatus);
      showMessage("Status updated successfully", "success");
      fetchData();
    } catch (err) {
      showMessage("Error updating status", "error");
    } finally {
      setLoading(false);
    }
  };

  //  RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  //  SEARCH FILTER
  const filteredStores = stores.filter(
    (store) =>
      store.storeName.toLowerCase().includes(searchText.toLowerCase()) ||
      store.storeCode.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <Breadcrumb pageTitle="Store" secondTitle="Masters" />

      <div className="row">
        <div className="card bg-white shadow-sm p-3">

          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-3 p-2`}
            >
              <span>{message}</span>
              <button type="button" className="btn-close" onClick={closeMessage} />
            </div>
          )} */}

          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          

          {/*  SEARCH + BUTTONS */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search Store"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <div className="ms-auto d-flex gap-2">
              <button
                className="d-inline-flex btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="d-inline-flex btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>
            </div>
          </div>

          {/*  TABLE */}
          <ListStore
            loading={loading}
            filteredStores={filteredStores}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />

        </div>
      </div>
    </>
  );
}
